"use client";

import React from "react";
import { Quote, CircleCheck, Star } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Michael R.",
  position: "CEO, Tech Company · San Jose",
  quote: "The most reliable airport transfer service in the Bay Area. Punctual, discreet, and the vehicle was absolutely immaculate.",
  rating: 5
}, {
  author: "Sarah L.",
  position: "VP of Operations · Silicon Valley",
  quote: "AAP Luxury Transfers has become our go-to for all executive transport. Their attention to detail and professional chauffeurs are unmatched.",
  rating: 5
}, {
  author: "David K.",
  position: "Executive Assistant · Fortune 500",
  quote: "Exceptional service for our board members. The hourly booking made our multi-city itinerary seamless and stress-free.",
  rating: 5
}];
export default function VoicesOfOurGuests() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="132757" id="voices-of-the-executive-class" className="relative py-24 lg:py-32 bg-background overflow-hidden dark" ref={ref}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598014/img/quote-watermark-gold.png)] bg-no-repeat bg-center bg-contain mix-blend-screen" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className={`text-center mb-16 lg:mb-24 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground mb-6 tracking-tight">
            What Our Clients Say
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full opacity-80" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 items-center max-w-7xl mx-auto">
          {testimonials.map((testimonial, i) => {
          const isCenter = i === 1;
          return <div key={i} data-index={i} className={`transition-all duration-1000 delay-${i * 200} transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} ${isCenter ? "lg:scale-110 z-10 shadow-2xl shadow-black/60" : "lg:scale-95 opacity-90 hover:opacity-100"}`}>
                <Card className="bg-card text-foreground border border-primary/10 h-full flex flex-col justify-between p-8 md:p-10 rounded-sm overflow-hidden relative group">
                  {}
                  <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl -mr-10 -mt-10 transition-opacity group-hover:opacity-100 opacity-50" />
                  
                  <div className="relative z-10">
                    <div className="flex justify-between items-start mb-8">
                      <Quote className="w-12 h-12 text-primary opacity-80" strokeWidth={1.5} />
                      <div className="flex gap-1">
                        {[...Array(testimonial.rating)].map((_, starIdx) => <Star key={starIdx} className="w-4 h-4 fill-primary text-primary" />)}
                      </div>
                    </div>
                    
                    <p className="font-serif text-xl md:text-[28px] leading-relaxed mb-10 text-foreground/95 italic">
                      "{testimonial.quote}"
                    </p>
                  </div>

                  <div className="flex items-center justify-between mt-auto pt-6 border-t border-primary/10 relative z-10">
                    <div>
                      <p className="font-bold text-sm text-primary tracking-widest uppercase font-sans">
                        {testimonial.author}
                      </p>
                      <p className="text-xs text-muted-foreground font-medium mt-1 uppercase tracking-wider font-mono">
                        {testimonial.position}
                      </p>
                    </div>
                    <Badge variant="secondary" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 border-none px-3 py-1 shadow-sm font-mono text-[10px] uppercase tracking-wider">
                      <CircleCheck className="w-3.5 h-3.5 mr-1.5" /> 
                      Verified
                    </Badge>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}